<template>
  <div>
    <v-card class="pa-3">
      <v-layout row wrap justify-end>
        <v-btn icon flat ripple @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-layout>
      <template v-if="!loading">
        <v-layout row wrap>
          <v-flex xs12>
            <h6>ประวัติการขอเข้าพื้นที่ของช่าง</h6>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs12 v-if="showData[0].unit_name">
                <span>ชื่อหน่วยงาน : </span><span>{{ showData[0].unit_name }}</span>
              </v-flex>
              <v-flex xs12 v-if="showData[0].staff_id">
                <span>รหัสพนักงาน : </span><span>{{ showData[0].staff_id }}</span>
              </v-flex>
              <v-flex xs12>
                <span>ชื่อ - นามสกุล : </span><span>{{ selectedUser.full_name }}</span>
              </v-flex>
              <v-flex xs12>
                <span>เบอร์โทรศัพท์ : </span><span>{{ selectedUser.phone_number }}</span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex xs6 class="mb-3">
            <v-pagination
              :total-visible="6"
              v-model="pageNumber"
              @input="changePage"
              :length="pagelength"
            ></v-pagination>
          </v-flex>
          <v-flex xs6 class="text-xs-right">
            <span style="width: max-content">
              ทั้งหมด <span class="primary-color">{{ total }}</span> รายการ
            </span>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="!loading">
          <v-card
            v-for="(request, index) in showData"
            :key="`request-${index}`"
            elevation="2"
            class="py-3 mb-3"
            style="border-radius: 20px; width: 100%"
          >
            <v-layout row wrap>
              <div style="padding-left: 24px; padding-right: 24px; width: 100%">
                <v-layout row wrap justify-space-between>
                  <v-flex class="primary-color align-center" style="display: flex"
                    ><h6 class="my-0">เลขคำขอ : {{ request.id }}</h6>
                    <div
                      class="ml-2"
                      :class="{
                        register: request.status == 'register',
                        pending: request.status == 'pending',
                        waiting: request.status == 'waiting',
                        approve: request.status == 'approve',
                        reject: request.status == 'reject'
                      }"
                    >
                      {{ mapStatus[request.status] }}
                    </div>
                  </v-flex>
                  <v-flex class="card-time">
                    {{ request.created_at | DateFormat('วันที่ DD/MM/YYYY เวลา HH:mm') }}
                  </v-flex>
                </v-layout>
                <v-flex xs12>
                  ชื่อศูนย์ <span class="text-gray">{{ request.branch_name }}</span>
                </v-flex>
                <v-layout row wrap class="mt-2">
                  <v-flex xs6 style="align-self: center"
                    >ตั้งแต่
                    <span class="text-gray">{{
                      request.start_time | DateFormat('วันที่ DD/MM/YYYY เวลา HH:mm')
                    }}</span></v-flex
                  >
                  <v-flex xs6 style="align-self: center"
                    >จนถึง
                    <span class="text-gray">{{
                      request.end_time | DateFormat('วันที่ DD/MM/YYYY เวลา HH:mm')
                    }}</span></v-flex
                  >
                </v-layout>
              </div>
              <v-flex xs12 class="mt-3" v-if="request.log && request.log.length">
                <v-expansion-panel style="border-color: transparent; box-shadow: none">
                  <v-expansion-panel-content>
                    <template v-slot:header class="p-0">
                      <span>บันทึกกิจกรรม</span>
                    </template>
                    <v-card>
                      <!-- <v-card-text> item</v-card-text> -->
                      <v-data-table :headers="headers" :items="request.log" hide-actions>
                        <template v-slot:items="props">
                          <tr>
                            <td>{{ props.item.name }}</td>
                            <td>
                              {{ props.item.action_by }}
                            </td>
                            <td>{{ props.item.note }}</td>
                            <td>{{ props.item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}</td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
            </v-layout>
          </v-card>
        </v-layout>
        <v-layout v-else row wrap justify-center align-content-center>
          <v-progress-circular
            class="mt-5"
            indeterminate
            color="primary"
            :value="48"
          ></v-progress-circular>
        </v-layout>
        <div>
          <v-pagination
            :total-visible="6"
            v-model="pageNumber"
            @input="changePage"
            :length="pagelength"
          ></v-pagination>
        </div>
      </template>
      <v-layout v-else class="mt-5" row wrap justify-center align-content-center>
        <v-progress-circular
          indeterminate
          color="primary"
          :size="64"
          :width="8"
        ></v-progress-circular>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import yasaleAcApi from '@/api/yasale-ac'

export default {
  props: {
    value: {
      default: null
    }
  },
  components: {},
  data() {
    return {
      limit: 5,
      offset: 0,
      total: 0,
      showData: [],
      headers: [
        { text: 'ชื่อกิจกรรม', value: 'name', sortable: false },
        { text: 'ผู้ดำเนินการ', value: 'action_by', sortable: false },
        { text: 'สาเหตุ', value: 'note', sortable: false },
        { text: 'บันทึกเวลา', value: 'timestamp', sortable: false }
      ],
      pageNumber: 1,
      pagetmp: 1,
      loading: false,
      selectedUser: null,
      mapStatus: {
        register: 'รอตรวจสอบข้อมูลช่าง',
        pending: 'รอพิจารณา',
        approve: 'อนุมัติ',
        reject: 'ไม่อนุมัติ',
        waiting: 'รอรหัส PIN'
      }
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        var total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  async mounted() {
    this.loading = true
    if (this.value) {
      this.selectedUser = this.value
      await this.getLog()
    }
    this.loading = false
  },
  methods: {
    changePage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit

        vm.getLog()
      }
    },
    async getLog() {
      const vm = this
      return new Promise(async (resolve, reject) => {
        try {
          let resData = await yasaleAcApi.getRequestWithLog({
            config: {
              params: {
                page_id: vm.selectedBot.pageid,
                member_id: vm.selectedUser.member_id,
                limit: vm.limit,
                offset: vm.offset
              }
            }
          })
          vm.loading = false
          if (resData.data && resData.data.total && resData.data.data) {
            vm.total = resData.data.total
            vm.showData = resData.data.data
            resolve(true)
          }
        } catch (error) {
          vm.loading = false
          reject(error)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.caption {
  font-size: 14px !important;
  margin-bottom: 12px;
}
input {
  max-height: 40px;
}
.card-time {
  text-align: end;
  color: #a9a9a9;
  font-size: 14px;
}
.text-gray {
  color: #a9a9a9;
}
.pending {
  width: max-content;
  background-color: #f4c13d;
  padding: 5px 10px;
  border: 1px solid transparent;
  border-radius: 17px;
  color: white;
}
.approve {
  width: max-content;
  background-color: #05c519;
  padding: 5px 10px;
  border: 1px solid transparent;
  color: white;
  border-radius: 17px;
}
.reject {
  width: max-content;
  background-color: #e12005;
  padding: 5px 10px;
  border: 1px solid transparent;
  color: white;
  border-radius: 17px;
}
.waiting {
  width: max-content;
  background-color: #03a9f4;
  padding: 5px 10px;
  border: 1px solid transparent;
  color: #fff;
  border-radius: 17px;
}
.register {
  width: max-content;
  background-color: #f4953d;
  padding: 5px 10px;
  border: 1px solid transparent;
  border-radius: 17px;
  color: white;
}
.v-expansion-panel__header {
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/YasaleAc/RequestLogDialog.vue